import ContextMenu from './ContextMenu.vue'
import ContextMenuItem from './ContextMenuItem.vue'

export interface Props {
  trigger?: number
}

export default ContextMenu
export { ContextMenuItem };
